namespace TR {

    'use strict';

    class HolidayDealsPromo {

        summary: any;
        blocks: any;
        flags: any;

        constructor(
            private $location: ng.ILocationService,
            private $scope: any,
            private $rootScope: any,
            private filtering: any,
            private analytics: any,
            private broker: Core.Broker,
            private holidayDeals: any,
            private holidayDealsPromoService: any,
            private resourceService: Core.ResourceService
        ) {
            $scope.$emit('block', {
                title: resourceService.get('SEARCHINGDEALS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-holidayDealsResults'
            });

            this.$rootScope.hideFooterToolbar = true;
            this.analytics.track('mixpanel', 'HolidayDealsInsLanding');
            this.holidayDealsPromoService.getInfoPromo().then(info => {
                this.summary = info.summary;
                this.blocks = info.blocks;
                this.$scope.$emit('unblock');
            });

            this.flags = {
                searchUnit: true,
                clicks: 0
            };

            this.broker.subscribe('holidayDealsPromoController', 'PROMO_OVERLAY', ({ data }) => {
                this.flags.clicks = this.flags.clicks + 1;
                this.flags.holidayType = data.group === 'type' ? data.type : this.flags.holidayType;
                this.flags.budget = data.group === 'budget' ? data.type : this.flags.budget;
            });

            this.broker.subscribe('holidayDealsPromoController', 'REFRESHSEARCH', () => {
                this.holidayDealsPromoService.getInfoPromo().then(info => {
                    this.summary = info.summary;
                    this.blocks = info.blocks;
                });
            });

            $scope.$on('$destroy', () => {
                this.broker.unsubscribe('holidayDealsPromoController', 'PROMO_OVERLAY');
                this.broker.unsubscribe('holidayDealsPromoController', 'REFRESHSEARCH');
            });
        }

        toggleSearchUnit() {
            this.flags.searchUnit = !this.flags.searchUnit;
        }

        goToDeals() {
            this.broker.unsubscribe('holidayDealsPromoController', 'PROMO_OVERLAY');
            this.broker.unsubscribe('holidayDealsPromoController', 'REFRESHSEARCH');
            this.$scope.$emit('block', {
                title: this.resourceService.get('SEARCHINGDEALS'),
                subtitle: this.resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-holidayDealsResults'
            });
            const params = this.$location.search();
            this.analytics.track('mixpanel', 'HolidayInspSelected', {
                Budget: this.flags.budget,
                Type: this.flags.holidayType,
                Clicks: this.flags.clicks
            });
            this.$location.search('flex', 15);
            this.$location.path('/holidaydeals');
        }
    }

    angular
        .module('TR')
        .controller('HolidayDealsPromo', HolidayDealsPromo);
}
